export const apiEndPoints = {
  USER_TYPE: "/UserType/GetAppUserType",
  // USER_TYPE: "/UserType",
  GET_LANGUAGE: "/Language",
  VALIDATE_USER: "/Login/ValidateUser",
  SEND_OTP: "/Login/SendOTP",
  SEND_OTP_ON_CALL: "/Login/OTPOnCall",
  VERIFY_OTP: "/Login/VerifyOTP",
  LOGIN: "/Login/UserLogin",
  GET_TOKEN: "/Login/UserAuthentication",
  LOGIN_WITH_OTP: "Login/LoginwithOTPs",
  REGISTER: "/Login/UserRegistration",
  UPDATE_PROFILE: "/Login/UpdateUsersProfile",
  UPDATE_PROFILE_NO_IMAGE: "/Login/UpdateUsersProfileNoImage",
  GET_GENDER: "/Gender",
  GET_GRADE: "/Grade/GetActive",
  GET_STATES: "/State",
  GET_BLOCK: "/Block/GetBlockByDistrict",
  GET_DISTRICT_BY_STATE_ID: "/District/GetDistrictByState",
  GET_SCHOOL_BY_DISTRICT_ID: "/School/GetSchools",
  FORGOT_PASSWORD: "/Login/SetPassword",
  GET_LMS_URL: "/LMSConfiguration/GetActiveURLWeb",
  GET_APPLICATION_TEXT:
    "/ApplicationTranslatedText/GetApplicationTextByLanguage",
  GET_SCHOOL_BY_UDISE: "/SchoolMaster/GetSchoolByUdiseCode",
  GET_CERTIFICATE_TYPE: "/CertificateType",
  GET_OCCUPATION: "Occupation/GetActive",
  GET_BOARD: "SchoolBoard/GetActive",
  GET_SCHOOL_TYPE: "SchoolType/GetActive",
  GET_EDUCATIONALSTATUS: "EducationType/GetActive",
  DACTIVATE_USER: "Login/DeactivateUser",
  ACTIVATE_USER: "Login/RecoverAccount",
  GET_PROFESSION: "/Profession/GetProfession",
  GET_QUALIFICATION: "/Profession/GetQualification",
  GET_SPECIALIZATION: "/Profession/GetSpecialization",
  GET_CheckProfileCompletion_ByUserId: "/Login/CheckProfileCompletion",
  GET_SCHOOL_BY_UDISE_SchoolApi: "/SchoolMaster/GetSchoolByUdiseCode",
  GET_SCHOOL_BY_BlockId_SchoolApi: "/SchoolMaster/GetSchoolsByBlockId",
  GetSentNotification_CommApi: "/Notification/PRIN/GetSentNotification",
  MarkReadNotification_CommApi: "/Notification/PRIN/MarkReadNotification",
  MarkReadAllNotification_CommApi: "/Notification/PRIN/MarkReadAllNotification",
  GET_Reasons: "/Login/GetSchoolReasons",
  CaseTransfer_CaseTransferProcess: "/CaseTransfer/CaseTransferProcess",
  CaseTransfer_GetSchoolByStudentDetails:
    "/CaseTransfer/GetSchoolByStudentDetails",
  CaseTransfer_CheckAssessedStudent: "CheckAssessedStudent",
  CaseTransfer_SendCaseTransferRequest: "/CaseTransfer/SendCaseTransferRequest",
  CaseTransfer_StudentCaseTransferHistory: "StudentCaseTransferHistory",
  CaseTransfer_GetActiveQuestionAdvanceScreening:
    "GetActiveQuestionAdvanceScreening",
  CaseTransfer_PostAdvanceScreeningConcerns:
    "/CaseTransfer/PostAdvanceScreeningConcerns",
  CaseTransfer_ButtonBehaviour: "ButtonBehaviour",
  CaseTransfer_ReScreening: "ReScreening",
  CaseTransfer_ScreeningProfilerHistory: "ScreeningProfilerHistory",
  Validate_Student_Age_Criteria: "/Screening/ValidateStudentAgeCriteria",
  
};
